import { ComponentView } from "binder";
import { PopupViewModel } from "../popup/popup-viewModel";
import { TogglePopupViewModel } from "./togglePopup-viewModel"

export class TogglePopupView extends ComponentView<TogglePopupViewModel>{
    GetViewUniqueId(): string {
        return "V-6207D3E1-CF91-4919-8ECA-2CAAA0AED0D3"
    }
    loadHtml(): string {
        let element = require('./togglePopup.html').default;
        let style = require('./togglePopup.less');
        return element;
    }
    constructor() {
       super();
    }

    public set popup(v: PopupViewModel) { this._popup = v; } public get popup(): PopupViewModel { return this._popup;} private _popup: PopupViewModel;
    public set thisElement(v: HTMLElement) { this._thisElement = v; } public get thisElement(): HTMLElement { return this._thisElement;} private _thisElement: HTMLElement;
    public set popupContainer(v: HTMLElement) { this._popupContainer = v; } public get popupContainer(): HTMLElement { return this._popupContainer;} private _popupContainer: HTMLElement;
    public set closeoncontainerclick(v: boolean) { this._closeoncontainerclick = v; } public get closeoncontainerclick(): boolean { return this._closeoncontainerclick;} private _closeoncontainerclick: boolean;
    public set closeoncontrolclick(v: boolean) { this._closeoncontrolclick = v; } public get closeoncontrolclick(): boolean { return this._closeoncontrolclick;} private _closeoncontrolclick: boolean;
    public set preferredwidth(v: string) { this._preferredwidth = v; } public get preferredwidth(): string { return this._preferredwidth;} private _preferredwidth: string;
    public set usebody(v: boolean) { this._usebody = v; } public get usebody(): boolean { return this._usebody;} private _usebody: boolean;
    
    onRenderCompleted(){
        this.thisElement = <HTMLElement>this.firstlevelElement;
        this.popupContainer = this.firstlevelElement.querySelector('.v-6207d3e1-cf91-4919-8eca-2caaa0aed0d3-popup');
        this.popup = (<any>this.popupContainer).binderRelatedView.dataContext;
    }
    append(...nodes: (Node | string)[]): void{
        nodes.forEach(node=>{
            if(node instanceof HTMLElement && node.classList.contains('popup')){
                (<any>this.popupContainer).binderRelatedView.append(node);
            }else{
                this.firstlevelElement.append(node);
            }
        });
    }

    toggle(e:MouseEvent){
        if(this.closeoncontrolclick==false || this.dataContext.isshowing==false)
            this.dataContext.toggle();
        if(this.dataContext.isshowing){
            this.firstlevelElement.dispatchEvent(new Event('bindercomponentspopupignorewindowclick'));
            e.stopPropagation();
            let new_event = new MouseEvent(e.type, e)
            window.dispatchEvent(new_event);
        }else{
            e.stopPropagation();
        }
    }

    ignoreWindowClick(){
        this.dataContext.ignoreWindowClick();
    }
}
